// extracted by mini-css-extract-plugin
module.exports = {"container":"logos_container__1Nm7K","link":"logos_link__2zTqT"};